export default __webpack_public_path__ + "static/media/Gellix-Regular.47dd9b4f.woff";